export default "__VITE_ASSET__vZZDBthi__"